"use client"

import { usePathname, useRouter } from "@/i18n/routing";
import { useLocale } from "next-intl";
// import translationsMap from '@/app/[locale]/blog/translations-map.json'
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button";
import { Icons } from "@/components/icons";

const languages = [
  { code: 'en-us', name: 'English', flag: '🇺🇸', short: 'EN' },
  { code: 'es-es', name: 'Español', flag: '🇪🇸', short: 'ES' },
] as const;

type LanguageCode = typeof languages[number]['code'];

export function LanguageSwitcher() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  const currentLanguage = languages.find(lang => lang.code === locale);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="rounded-full gap-1">
          {/* {currentLanguage?.flag} {currentLanguage?.name} */}
          {/* {currentLanguage?.flag} */}
          <Globe className="size-3.5"/><span className="tracking-tight">{currentLanguage?.short}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((language) => (
          <DropdownMenuItem
            key={language.code}
            onClick={async () => {
              // If on a blog detail page, map to translated slug
              if (pathname.includes('/blog/')) {
                try {
                  const res = await fetch('/blog/translations-map.json', { cache: 'no-store' })
                  const map = (await res.json()) as any
                  const currentLocale = locale as string
                  const segments = pathname.split('/')
                  const blogIndex = segments.findIndex((s) => s === 'blog')
                  if (blogIndex === -1) throw new Error('No blog segment')
                  const slug = decodeURIComponent(segments.slice(blogIndex + 1).join('/'))
                  const byLocale = map?.byLocale as Record<string, Record<string, string>> | undefined
                  const byKey = map?.byKey as Record<string, Record<string, string>> | undefined
                  const key = byLocale?.[currentLocale]?.[slug]
                  let targetSlug: string | undefined
                  if (typeof key === 'string' && byKey && typeof byKey[key] === 'object') {
                    const targetMap = byKey[key] as Record<string, string>
                    targetSlug = targetMap[language.code]
                  }
                  if (targetSlug) {
                    router.replace(`/blog/${targetSlug}`, { locale: language.code })
                    return
                  }
                } catch {}
              }
              router.replace(pathname, { locale: language.code });
            }}
            className="gap-2"
          >
            {language.flag} {language.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
} 